export class PortableInfo {
  isOnlyPortable?= false;
  useOnlyUnitsMarkedMobile?= true;
  storeAtOptions?= ['facility', 'onSite'];
  quoteTypeOptions?= ['storage', 'localMove', 'movingAndStorage'];
  prepayAllDeliveries?: boolean;
  redirectFromUnitsPage?= false;
  unitsPageRedirect?: string;
  isDeliveryByZipCode?= false;
  useDeliveryZones?= false;
  minDays?: number;
  nextDeliveryDate?: Date;
  disableDays?: boolean[] = [false, false, false, false, false, false, false];
  locations: string[] = [];
  mapRadius = 50;
};



// WEBPACK FOOTER //
// ./src/ng2/app/models/portableInfo.ts